import { useState, useEffect } from "react";
import { useHistory,useParams } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import {usermanageService} from '../../../services/usermanageService';
import "assets/css/themecustom-style.css";
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';

const KROEwsListing = (props) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [krodata, setKROdata] = useState([]);
  const [fullloader,setLoader] = useState(false);
  const months = [{value:'01',label : 'Jan'},{value:'02',label :'Feb'},{value:'03',label :'March'},{value:'04',label :'April'},{value:'05',label :'May'},{value:'06',label :'June'},{value:'07',label :'July'},{value:'08',label :'Aug'},{value:'09',label :'Sept'},{value:10,label :'Oct'},{value:11,label :'Nov'},{value:12,label :'Dec'}];
  const [monthdata, setmonthdata] = useState(months);
  const [filtertype,setfiltertype] = useState('not_eligible');
  const [statuslist, setStatusdata] = useState([]);
  const [reviewerlist, setReviewerData] = useState([]);
  const [uniqueuserslist, setUniqueUsersData] = useState([]);
  const user_info = JSON.parse(localStorage.getItem("user-info"));
const initialData = {
  user_id : '',
  month_year : '',
  reviewer_id : '',
  status : '',
  approval:'',
  manager_approval:''
}
const [inputFields, setInputfields] = useState(initialData);
  function get_unique_userslist(){
    usermanageService.getusersforkro().then((response)=>{
      setUniqueUsersData(response.data.users);
    });
  }
  function get_status_list() {
    usermanageService.krogetstatus().then((response) => {
      setStatusdata(response.data.status);
    });
  }
  const history = useHistory();
  const handlePageClick = (e, index) => {
    window.localStorage.setItem('pnum', index)
    e.preventDefault();
    get_kro_list(index);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    window.localStorage.setItem('pnum', prev)
    get_kro_list(prev);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    window.localStorage.setItem('pnum', next)
    get_kro_list(next);
  };

  const get_kro_list = async (pageNumber = 1,e,sortfield,sortorder,filtertype='') => {
    usermanageService.getkroewslist(pageNumber,inputFields,sortfield,sortorder,filtertype).then((response) => {
      setKROdata(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setLastPageData(response.data.data.last_page);
      setReviewerData(response.data.reviewer_arr)
    });
  };
  const addkro = ()=>{
    history.push("/admin/krocalculation/");
  }
  const noteligibleuser = ()=>{
    history.push("/admin/noteligibleuser/");
  }
  const editclick = (user_id,month_year) => {
    //history.push("/admin/krocalculation/"+user_id+"/"+month_year);
    const url = "/admin/krocalculation/" + user_id + "/" + month_year;
    window.open(url, "_blank");  // Opens in a new window or tab
    
  }
  function inputhandler1(e,field) {
    if(field=='month_year' || field=='approval' || field=='manager_approval'){
      setInputfields((prevInputFields)=>({ ...prevInputFields, [field]: e.target.value } ));
    }else{
      console.log()
    setInputfields((prevInputFields) => ({
      ...prevInputFields,
      [field]: e.value,
    }));
    }
  
  }

  const editField = (value, field, id,user_id, index) => {
    let temp_st = [...krodata];
    let temp_ele = { ...temp_st[index] };
   
    if((field == 'approval' || field == "manager_approval") && value == 2){
      // if reject then remarks should not be blank
      if(temp_ele.remarks == '' || temp_ele.remarks == null){
        toast.error('Remarks is required');
        return;
      }
    }
    
    usermanageService.editKRORow(value, field, id,user_id).then((response) => {
   
      if(response.status == 200){
          if (field == "approval") {
            if (value == 1) {
              temp_ele.approval = "Discussed & Approved";
            } else if (value == 2 && temp_ele.status != 17) {
              temp_ele.approval = "Rejected";
              temp_ele.status_name = "Not Complete";
            }else{
              temp_ele.approval = "";
            }
          }

          if (field == "manager_approval") {
            if (value == 1) {
              temp_ele.manager_approval = "Discussed & Approved";
            } else if (value == 2 && temp_ele.status != 17) {
              temp_ele.manager_approval = "Rejected";
              temp_ele.status_name = "Not Complete";
            }else{
              temp_ele.manager_approval = "";
            }
          }
         
          toast.success(response.data.message);
          temp_ele[field] = value;
         
      }else{
          toast.error(response.data.message);
      }
    temp_ele.mainediting = false;
     temp_st[index] = temp_ele;
     setKROdata(temp_st);
    });
  };

  const handlemaineditRow = (index) => {
      let temp_state = [...krodata];
      let temp_element = { ...temp_state[index] };
      temp_element.mainediting = true;
      temp_state[index] = temp_element;
      setKROdata(temp_state);
  };
    // sorting functon
    const [sortfield,setsortfield] = useState('');
    const [sortorder,setsortorder] = useState('asc');
    function sortTable(field){
      console.log(field)
      setsortfield(field);
      if(sortorder=='asc'){
        setsortorder('desc');
      }else{
        setsortorder('asc');
      }
    }
    
  useEffect(() => {
    const pnum = window.localStorage.getItem('pnum');
    console.log(pnum)
    get_unique_userslist();
    get_kro_list(pnum);
    get_kro_statstics_data();
    get_status_list();
  }, [sortorder]);
  function downloadReport(){
    
    usermanageService.download_ews_data(inputFields).then((response) => {
    
    });
  }
  const[countData,setCountData] = useState([]);
  const get_kro_statstics_data = ()=>{
    
    usermanageService.KROCountData(inputFields).then((response) => {
      setCountData(response.data.data);
    });
  }
 
  const archieveRows = (e,id,flag) => {
    e.preventDefault();
    swal({
      title: "Are you sure want to remove?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((isConfirm) => {
      if (isConfirm){
    usermanageService.deleteKro(id).then((response) => {
      if(response.status == 200){
       
        get_kro_list();
       toast.success(response.data.message);
        
       
      }else{
        toast.error(response.data.message);
      }
    });
  }
});
  }
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
      
      
        <Row className="mt-5">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              <CardHeader className="border-0">
              <Row className="filter" style={{padding:'0 1%'}}>
               {/* <div className="filter" style={{width:'100%'}}> */}
                   <div className="col-xl-2 col-md-3 col-xs-12">
                    <h3 className="clientformtag"> Select User</h3>
                   {(uniqueuserslist.length > 0) ? 
                   <Select 
                   
                   className="input-group-alternative " 
                   name="user_id"
                   options={uniqueuserslist} // set list of the data
                   onChange={(e) => inputhandler1(e,'user_id')}
                  //  value={usersearch}
                   searchable
                   isClearable={false}
                 />
                 : null }
                  </div>
                  <div className="col-xl-2 col-md-3 col-xs-12">
                      <h3 className="clientformtag"> Select Reviewer</h3>
                      <Select 
                        className="input-group-alternative " 
                        name="reviewer_id"
                        options={reviewerlist} // set list of the data
                        onChange={(e) => inputhandler1(e,'reviewer_id')}
                        searchable
                        isClearable={false}
                    />
                   </div>
                
                  <div className="col-xl-2 col-md-3 col-xs-12">
                    <h3 className="clientformtag"> Select month</h3>
                    <input type="month"
                                      className="form-control"
                                      name="month_year"
                                      onChange={(e) => { inputhandler1(e,'month_year')}}
                                      value={inputFields.month_year}
                                      options={monthdata}
                                      required
                                      />
                                       {inputFields.month_year && <div style={{ marginTop: 20, lineHeight: '25px' }}></div>}
                      
                  </div>
                  
                  
                                  
                    <div className="col-xl-3 col-md-3 col-xs-12">
                    <br></br>
                      <Button className="col-xl-6 btn btn-primary"  onClick={(e) => get_kro_list()}>Search</Button>
                    </div>
                    <div className="col-xl-2 col-md-3 col-xs-12">
                      <Button
                      style={{textAlign:"center"}}
                      className="btn btn-icon-clipboard  ml-2"
                      type="button"
                      onClick={downloadReport}
                      
                      title="Download Report"
                    >
                    <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
                  </Button></div>
                    {/* </div> */}
                </Row>
                <Row className="filter" style={{ padding: "0 25px" }}>
                  <div className="d-flex">
                  <h3 className="mb-0 mt-2" style={{ fontSize: "20px" }}>
                    Overall Performance
                  </h3>
                  
                 
                  </div>
                  <br></br>
                  <br></br>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <th scope="col" >Emp code</th>
                  <th scope="col" >Name</th>
                  <th scope="col" >Email</th>
                  <th scope="col">Reviewer</th>
                  <th scope="col">Date of joining</th>
                  <th scope="col">Month</th>
                  <th scope="col" className="whitespace">One on one assessment</th>
                  <th scope="col" className="whitespace" >Performance Trend</th>
                  <th scope="col" className="whitespace">Leave Record</th>
                  <th scope="col" className="whitespace" >Behaviour/Motivation</th>
                  <th scope="col" className="whitespace" >Tenure in Current role</th>
                  <th scope="col" className="whitespace" >Manager's Prespective</th>
                  <th scope="col">Score</th>
                  <th scope="col">Rating</th> 
                </thead>
                <tbody>
                  {krodata && krodata.length && krodata != null ? (
                    krodata.map((item, i) => {
                      if (item === undefined) return null;

                      const riskScore = (100 - item.total_weightage_score / 5).toFixed(2);
                      let riskLabel = "";
                      if (riskScore < 16) {
                        riskLabel = "Low Risk";
                      } else if (riskScore >= 16 && riskScore < 32) {
                        riskLabel = "Medium Risk";
                      } else {
                        riskLabel = "High Risk";
                      }
                      let performLabel = "";
                      if(item.manager_prespective <= 1){
                        performLabel = "Low Performer";
                      }else if(item.manager_prespective <= 3){
                        performLabel = "Medium Performer";
                      }else if(item.manager_prespective <= 5){
                        performLabel = "High Performer";
                      }
                      // Assign row class based on riskScore
                      let rowClass = "";
                      if (riskLabel == 'Low Risk' && performLabel == 'High Performer') {
                        rowClass = "green-row";
                      } else if (riskLabel == 'Low Risk' && performLabel == 'Medium Performer') {
                        rowClass = "green-row";
                      } else if (riskLabel == 'Low Risk' && performLabel == 'Low Performer') {
                        rowClass = "yellow-row";
                      } 
                       else if (riskLabel == 'Medium Risk' && performLabel == 'Medium Performer') {
                        rowClass = "orange-row";
                      } else if (riskLabel == 'Medium Risk' && performLabel == 'Low Performer') {
                        rowClass = "orange-row";
                      } else if (riskLabel == 'Medium Risk' && performLabel == 'High Performer') {
                        rowClass = "orange-row";
                      }
                      else if (riskLabel == 'High Risk' && performLabel == 'Medium Performer') {
                        rowClass = "red-row";
                      } else if (riskLabel == 'High Risk' && performLabel == 'Low Performer') {
                        rowClass = "red-row";
                      }else if (riskLabel == 'High Risk' && performLabel == 'High Performer') {
                        rowClass = "darkorange-row";
                      } 
                      else {
                        rowClass = "red-row";
                      }
                      performLabel = performLabel+' - ';
                      return (
                        <tr key={i} className={rowClass}>
                          <td>{item.emp_code}</td>
                          <td>{item.name}</td>
                          <td>{item.email}</td>
                          <td>{item.reviewer}</td>
                          <td>{item.joining_date}</td>
                          <td>{item.month}</td>
                          <td>{item.one_on_one}</td>
                          <td>{item.performance_trend}</td>
                          <td>{item.leave_record}</td>
                          <td>{item.behavior_motivation}</td>
                          <td>{item.tenure_in_role}</td>
                          <td>{item.manager_prespective}</td>
                          <td>{riskScore}</td>
                          <td>{performLabel} {riskLabel}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>

              </Table>

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default KROEwsListing;
